<template>
    <div>
        <h2>Login</h2>
        <form @submit.prevent="submit" ref="form" action="auth/login">
            <fieldset>
                <div :class="{ 'error': errors.email }">
                    <input type="email" v-model="form.email" name="email" placeholder="Email" required tabindex="1" />
                    <p v-if="errors.email">{{ errors.email }}</p>
                </div>
                <div :class="{ 'error': errors.password }">
                    <password-input v-model="form.password" name="password" placeholder="Password" required tabindex="2" />
                    <p v-if="errors.password">{{ errors.password }}</p>
                </div>
                <div class="row">
                    <div class="col-6">
                        <label>
                            <input type="checkbox" name="remember" v-model="form.remember" tabindex="3" />
                            Remember me
                        </label>
                    </div>
                    <div class="col-6 text-right">
                        <router-link :to="{ name: 'lost-password' }" tabindex="5">Lost your password?</router-link>
                    </div>
                </div>
            </fieldset>
            <p>By signing in or creating an account, you agree with our
                <a href="https://pdfshift.io/terms/" title="Read our Terms of Service" target="_blank" tabindex="7">Terms of Service</a> and
                <a href="https://pdfshift.io/privacy/" title="Read our Privacy policy" target="_blank" tabindex="8">Privacy Policy</a>.</p>
            <div>
                <button-loader label="Sign in" :sending="sending" :disabled="disabled" tabindex="4" class="btn-full" />
            </div>
            <div style="margin-top: 20px; font-size: .9em; text-align: center; border-top: solid 1px #ccc; padding-top: 20px;">
                <p>Don't have an account yet?<br />
                    <a href="https://pdfshift.io/register" title="Create your account" target="_blank" tabindex="6">Create your account</a>
                </p>
            </div>
        </form>
    </div>
</template>

<script>
import VueForm from '@/plugins/VueForm'
import ButtonLoader from '@/components/ButtonLoader'
import PasswordInput from '@/components/PasswordInput'

export default {
    components: { ButtonLoader, PasswordInput },
    mixins: [VueForm],
    data () {
        return {
            form: {
                email: null,
                password: null,
                remember: false
            }
        }
    },
    methods: {
        processSubmit (body) {
            this.$store.dispatch('connect', body.token)
            this.$store.commit('set', body.account)

            if ('next' in this.$route.query && this.$route.query.next && this.$route.query.next.substr(0, 5) === '/env/') {
                this.$router.push(this.$route.query.next)
            } else {
                this.$router.push({ name: 'dashboard' })
            }
        }
    }
}
</script>

<style scoped lang="scss">
    form>p {
        text-align:center;
        margin: 20px 0;
        font-size: .9em;
        font-style: italic;
    }
</style>
